import { XIcon, ClockIcon } from './Icons';

const FIELD_LABELS = {
  project: 'Project / Client', sponsorship: 'Sponsorship', designation: 'Designation',
  status: 'Status', basicSalary: 'Basic Salary', allowance: 'Allowance', totalSalary: 'Total Salary',
  iqamaStatus: 'Iqama Status', iqamaExpiry: 'Iqama Expiry', qiwaEnd: 'Qiwa Expiry',
  passportExpiry: 'Passport Expiry', healthInsuranceExpiry: 'Insurance Expiry',
  deductionBalance: 'Deduction Balance', iban: 'IBAN', contact: 'Contact',
};

export default function HistoryModal({ emp, onClose }) {
  const history = [...(emp.history || [])].reverse(); // newest first
  return (
    <div className="fixed inset-0 z-[55] flex items-center justify-center p-4"
      style={{ background: 'rgba(15,27,51,0.5)', backdropFilter: 'blur(4px)' }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="bg-white rounded-2xl w-[560px] max-w-full max-h-[85vh] flex flex-col shadow-2xl">
        <div className="flex items-center gap-3 px-6 py-5 border-b border-slate-100 flex-shrink-0">
          <div className="w-10 h-10 rounded-xl bg-[#0f1b33] flex items-center justify-center">
            <ClockIcon size={18} className="text-white" />
          </div>
          <div className="flex-1">
            <h2 className="text-base font-bold text-slate-800">Change History</h2>
            <p className="text-xs text-slate-400">{emp.name} · {history.length} recorded changes</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:bg-slate-100 transition-all">
            <XIcon size={16} />
          </button>
        </div>
        <div className="overflow-y-auto flex-1 p-6">
          {history.length === 0 ? (
            <div className="text-center py-10 text-slate-400 text-sm">
              No changes recorded yet. Edits to project, sponsorship, salary, status, and document dates are logged automatically.
            </div>
          ) : (
            <div className="space-y-0">
              {history.map((h, i) => (
                <div key={i} className="relative pl-6 pb-5 last:pb-0">
                  {/* timeline */}
                  <div className="absolute left-[5px] top-2 bottom-0 w-px bg-slate-100" style={i === history.length - 1 ? { display: 'none' } : {}} />
                  <div className="absolute left-0 top-1.5 w-[11px] h-[11px] rounded-full bg-[#fde8e3] border-2 border-[#fb866d]" />
                  <div className="text-[13px]">
                    <span className="font-semibold text-slate-800">{FIELD_LABELS[h.field] || h.field}</span>
                    <span className="text-slate-400"> changed</span>
                  </div>
                  <div className="text-[12.5px] mt-0.5">
                    <span className="px-2 py-0.5 rounded bg-red-50 text-red-500 line-through">{String(h.from) || '—'}</span>
                    <span className="text-slate-300 mx-1.5">→</span>
                    <span className="px-2 py-0.5 rounded bg-emerald-50 text-emerald-600 font-medium">{String(h.to) || '—'}</span>
                  </div>
                  <div className="text-[11px] text-slate-400 mt-1">
                    {new Date(h.date).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })} · {h.by}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}